
import processQuerystring from '~/mixins/processQuerystring.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingProductListingMixins from '~/mixins/eventTrackingProductListingMixins';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  name: 'ProductListingWrapper',
  mixins: [processQuerystring, eventTrackingMixins, eventTrackingProductListingMixins, lgmMixin],

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    perPage: {
      type: Number,
      required: true,
      default: 15,
    },
    resultMessage: {
      type: String,
      required: true,
      default: '',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    assumptionTooltipHtml: {
      type: String,
      required: true,
      default: '',
    },
    selectedSortingLogic: {
      type: String,
      required: false,
      default: '',
    }
  },

  data: () => ({
    productListingComponentRendered: false,
    previousLocale: null
  }),

  computed: {
    displayProducts() {
      return this.data?.slice(
        (this.currentPage - 1) * this.perPage,
        (this.currentPage - 1) * this.perPage + this.perPage
      );
    },

    total() {
      return this.data?.length;
    },

    totalPage() {
      return Math.ceil(this.total / this.perPage);
    },

    currentPage: {
      get() {
        const value = this.$route.query.page || '1';
        return parseInt(value);
      },

      set(newValue) {
        this.updateQueryStringForCurrentPage(newValue);
        return newValue;
      },
    },

    compactDisplayMode: {
      get() {
        return this.$route.query.compact === 'true' || false;
      },

      set(newValue, oldValue) {
        if (newValue !== oldValue) this.updateQueryStringForCompactDisplayMode(newValue);
        return newValue;
      },
    },
  },

  watch: {
    total() {
      this.$nextTick(() => {
        //Check if the language has changed
        if(this.$i18n.locale !== this.previousLocale) {
          // console.log('Language changed, not resetting currentPage');
          this.previousLocale = this.$i18n.locale;
        }
        else {
          // console.log('Total changed');
          this.currentPage = 1;
        }
      });
    },
    data(newVal, oldVal) {
      if(newVal !== oldVal && newVal.length > 0 && this.productListingComponentRendered) {
        setTimeout(() => {
          this.handleEventTracking_promotionBannerLoaded()
        }, 2000)
      }
    },
    '$route.query': {
      handler(newVal, oldVal) {
        if(newVal !== oldVal) {
          // route changed
          this.productListingComponentRendered = false
          this.componentRendered = false
        }
      },
      deep: true,
      immediate: true
    },
    selectedSortingLogic(newVal, oldVal) {
      if(newVal !== oldVal) {
        // if sorting logic changed, go back to page 1
        this.currentPage = 1;
      }
    }
  },


  created() {
    // console.info('created() (products)...')
  },
  mounted() {
    // console.info('mounted() (products)...')
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
    // console.info('beforeUpdate() (productlisting)...')
  },
  updated() {
    // console.info('updated() (productlisting)...')
    this.productListingComponentRendered = true
  },

  methods: {
    toggleDetailDisplayMode() {
      this.compactDisplayMode = false;
    },

    toggleCompactDisplayMode() {
      this.compactDisplayMode = true;
    },

    togglePageChanged(pageValue) {
      this.currentPage = pageValue.pageValue;
    },

    updateQueryStringForCurrentPage(pageValue) {
      if (pageValue === 1) {
        this.removeSingleQueryString('page');
      } else {
        this.extendQueryString({ page: pageValue });
      }
    },

    updateQueryStringForCompactDisplayMode(mode) {
      if (!mode) {
        this.removeSingleQueryString('compact');
      } else {
        this.extendQueryString({ compact: mode });
      }
    },

    handleEventTracking_promotionBannerLoaded() {
      const sponsoredPromotionItems = document.querySelectorAll(".product-results .sponsored-promotion")

      if (sponsoredPromotionItems?.length > 0) {
        // #2 count sponsoredPromotionItems
        sponsoredPromotionItems.forEach(element => {

          if (element.getAttribute('data-listener') === null) {
            element.setAttribute('data-listener', 'true')
  
            const cardData = this.extractDataFromProductCardNode(element)
  
            // #2 count sponsoredPromotionItems
            const eventTrackingParams = this.initEventTrackingParams()
  
            const productData = this.extractDataFromCurrentProductDetailPage()
  
            const insuranceCompany = productData.product.insurer_name
            const productScenarioCode = productData.product.scenario_code
            const productName = productData.product.product_name
            const productCategory = productData.product.product_category
            eventTrackingParams.a = 'promo_banner_impression'
            eventTrackingParams.l =  cardData.product.scenario_code
            eventTrackingParams.c = `decoder_promo_banner`
            eventTrackingParams.cd.insurer_name = cardData.product.insurer_name
            eventTrackingParams.cd.product_name = cardData.product.product_name
            eventTrackingParams.cd.product_category = cardData.product.product_category
  
            this.sendEventTracking(eventTrackingParams)
          }
        });

      }
    },


  },
};
